import styled from "styled-components";

import { Link } from "@components/Navigation/Link";

import { Text } from "@ui/Atoms/Text";
import { HorizontalRule } from "@ui/Atoms/HorizontalRule";

export const BurgerButton = styled(Link).attrs({
  as: "button",
  type: "button",
  $style: "medium_18",
})`
  ${props => props.theme.breakpointsV2.smallTablet} {
    display: none;
  }
`;

export const OpenLangDrawerButton = styled(Link).attrs({
  as: "button",
  type: "button",
  $style: "medium_18",
})`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.spacing_8};
  grid-column: 1 / 3;
`;

export const OpenLangDrawerButtonLabel = styled(Text)`
  flex: 1 1 auto;
`;

export const GridHorizontalRule = styled(HorizontalRule)`
  width: 100%;
  grid-column: 1 / 3;
`;
